
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ArticleList } from 'components/articleList'
import { RatingExplanationButton as Button } from 'components/ratingExplanationButton'
import {
  CategoryLinkIcon as Ci,
  ExternalLinkIcon as Ei
} from 'components/linkIcons'
import { ArticleLink } from 'components/articleLink'
import { Link } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p><em parentName="p">{`Karl Wild`}</em></p>
    <p>{`Es war ein guter bis sehr guter Sommer für die besten Ferienhotels in den
Bergen. Namentlich dank der Rückkehr ausländischer Gäste war die Auslastung fast
überall so gut wie vor Corona, oft sogar noch besser. Auch der Buchungsstand für
den Winter ist meist gut bis sehr gut. Doch es gibt Fragezeichen. Der Krieg in
der Ukraine, die Entwicklung in den wichtigen Auslandmärkten USA und UK, die
Frankenstärke, die Inflation, der drohende Strommangel, massiv gestiegene Öl-
und Gaspreise: Vieles trägt zur Verunsicherung bei. Nicht auszudenken, welche
Folgen Einschränkungen bei Bahnen und Liften, Wellness oder Schneekanonen auf
die Hotellerie und den ganzen Tourismus hätten.`}</p>
    <p>{`Bestes Ferienhotel mit fünf Sternen ist erneut `}<strong parentName="p">{`The Chedi Andermatt`}</strong>{`. Das
faszinierendste Hideaway der Alpen überrascht neu mit einem einzigartigen Winter
Village und zählt mittlerweile gar in den US-Medien zu den gefragtesten
Luxushotels der Welt. Weltklasse findet sich indes auch auf den Rängen dahinter.
Was die Schweizer Alpen-Luxushotellerie heute in allen Bereichen zu bieten hat,
ist beispiellos. Grösster Aufsteiger ist das vor eineinhalb Jahren eröffnete
Kempinski Palace in Engelberg. Der 100-Millionen-Franken-Palast hat dem ganzen
Ort den dringend benötigten neuen Schub gegeben. Erstmals in den Top Ten
erscheint das In Lain Hotel Cadonau, eine berauschend schöne Wohlfühloase im
Unterengadiner Flecken Brail. Prominenter Rückkehrer ist das ehrwürdige Mont
Cervin Palace in Zermatt. Der im Sommer aus dem Zermatterhof gekommene
Starhotelier Rafael Biner hat dem Palace die ärgerliche Behäbigkeit
ausgetrieben.`}</p>
    <p>{`In der Kategorie der besten Winterhotels mit vier Sternen steht erstmals das
`}<strong parentName="p">{`Walther in Pontresina`}</strong>{` ganz oben. Das von der Besitzerfamilie brillant
geführte Schlösschen war noch nie so gut; bezeichnenderweise gehört es auch zu
den am besten ausgelasteten Hotels im Land. Bereits auf Platz drei schaffte es
das Bergwelt in Grindelwald, ein Design-Hotel, das mit seinen Angeboten neue
Massstäbe im Berner Oberland setzt. Auffälligster Neuling ist das Parkhotel
Margna in Sils-Baselgia, ein für 26 Millionen Franken prächtig renoviertes Juwel
am Silsersee. Nummer eins unter den führenden Hotels mit drei Sternen bleibt das
`}<strong parentName="p">{`Spitzhorn in Saanen`}</strong>{` vor der wunderbaren Chesa Randolina am Silsersee.
Grösster Aufsteiger überhaupt ist das Hotel Steinbock in Pontresina (plus acht
Ränge). Die kleine Schwester des Hotels Walther wurde 1651 als Säumerstation
eröffnet und kunstvoll renoviert.`}</p>
    <p>{`Das Grace La Margna in St. Moritz und das Chasa Montana Hotel & Spa in Samnaun
sind zwei interessante 5-Stern-Superior-Häuser, die Mitte Dezember eröffnen und
noch nicht getestet werden konnten. Das Grace will die St. Moritzer Paläste
nicht konkurrenzieren. Als ganzjährig geöffnetes, luxuriöses Boutique-Hotel
erhebt es aber den Anspruch, mit einem urbanen Lifestylekonzept und innovativer
Gastronomie eine Nische zu besetzen und frischen Wind ins Tal zu bringen. Das
Chasa Montana ist im Sommer für zwanzig Millionen Franken umgebaut worden und
wird das erste Luxushotel im Samnaun sein. Im Februar eröffnet zudem die
thailändische Gruppe Six Senses in Crans-Montana ihr erstes Luxusresort, und
Multimilliardär Urs Wietlisbach hat mir dem im Sommer erworbenen Kulm in Arosa
ebenfalls Grosses vor. Der Gaube an die Schweizer Hotellerie ist ungebrochen.`}</p>
    <Button side='right' className='center aligned' mdxType="Button" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;